import $ from 'jquery';
import debounceRAF from '../utils/debounce_animation_frame';
import BaseNav from './base_nav_bar';
/**
 * NavBarHomepage is all the logic contained for what we need the navbar
 * to do on the homepage. Because other modules affect it's behavior we have
 * provided public methods to control it.
 */
class NavBarHomepage extends BaseNav {
    /**
     * constructor() scopes these methods so we can efficiently
     * attach / remove events, and cache jquery selectors.
     */
    constructor() {
        super();
        this.$navWrapper = $('.nav-bar-wrapper');
        this.$navBar = $('.navbar-brands-container');
        this.lastPosition = window.scrollY;
        this.scopedResizeListener = this.resizeListener.bind(this);
        this.scopedScroll = debounceRAF(this.scrollFn.bind(this));
    }

    /**
     * scrollFn() executes when we are on desktop and the user scrolls.
     * @returns {object} returns itself to support chaining
     */
    scrollFn() {
        let currentPosition = window.scrollY;
        if (currentPosition < this.$navWrapper.height() - this.$navBar.height()) {
            this.$navBar.css({
                position: 'relative',
                top: 0
            });
            return false;
        }

        this.$navBar.css({
            position: 'fixed',
            top: 0 + 'px'
        });
        this.lastPosition = window.scrollY;
        return this;
    }


    /**
     * scrollListener() attaches the events to the window for scroll
     * based on the matching media query.
     * @returns {object} returns itself to support chaining
     */
    scrollListener() {
        this.$window.on('scroll', this.scopedScroll);
    }

    /**
     * resizeListener() resets our listeners on an resize event
     * @returns {object} returns itself to support chaining
     */
    resizeListener() {
        return this.off().on();
    }

    /**
     * on() attaches all events for this module to execute
     * @returns {object} returns itself to support chaining
     */
    on() {
        this.off();
        this.navOpenOn();
        this.navCloseOn();
        // TODO: figure out how to resize when a different size ad loads in
        this.$window.on('fc:flexleaderboardRendered', () => {
            this.$navWrapper.css({
                'min-height': this.$navWrapper.height()
            });
            this.$window.on('resize', this.scopedResizeListener);
            return this.scrollListener();
        });
    }

    /**
     * off() removes all of the attached events for this module
     * and cleans up the added css. Later on we most likely will create
     * classes for this. TODO: @mbenin create classes for this behavior.
     * @returns {object} returns itself to support chaining
     */
    off() {
        this.navOpenOff();
        this.navCloseOff();
        this.$navBar.css({
            position: 'static',
            top: ''
        });
        this.$navWrapper.css({
            'min-height': ''
        });

        this.$window.off('scroll', this.scopedScroll);
        this.$window.off('resize', this.scopedResizeListener);
        return this;
    }
}

export default new NavBarHomepage();
